import React from "react";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { format, parseISO, isValid } from "date-fns";
import { es } from "date-fns/locale";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * DatePicker en español (locale es-ES) que devuelve la fecha como ISO yyyy-mm-dd
 * en el onChange para ser drop-in compatible con <input type="date">.
 */
export default function SpanishDatePicker({
  value,
  onChange,
  placeholder = "Selecciona fecha",
  testId,
}) {
  const date = value && isValid(parseISO(value)) ? parseISO(value) : undefined;

  const handleSelect = (d) => {
    if (!d) {
      onChange("");
      return;
    }
    onChange(format(d, "yyyy-MM-dd"));
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testId}
          className={cn(
            "w-full justify-start text-left font-normal h-10",
            !date && "text-slate-400",
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 text-slate-500" />
          {date ? format(date, "d 'de' MMMM yyyy", { locale: es }) : placeholder}
          {date && (
            <X
              role="button"
              aria-label="Limpiar fecha"
              className="ml-auto h-4 w-4 text-slate-400 hover:text-slate-700"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onChange("");
              }}
            />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleSelect}
          locale={es}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
